import { useState } from "react";
import Swal from "sweetalert2";
import {
    Backdrop,
    Typography,
    CircularProgress,
    Paper,
    Stack
} from "@mui/material";

import { useBarcodeScanner } from "../../utils/useBarcodeScanner";

export default function BarcodeOrder({ listID, onUpdate }) {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleAddToList = async (order) => {

        console.log(order)

        if (!order?.OrderID || !order?.CustomerID || !listID) {

            Swal.fire({
                text: "Some ID number is missing!",
                icon: "warning",
            });

            setOpen(false);
            return;
        }

        try {

            setLoading(true);

            const response = await fetch(
                `${apiUrl}manage_arrived/add_to_arrived_list.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        custID: order.CustomerID,
                        orderID: order.OrderID,
                        listID: listID,
                    })
                }
            );

            const result = await response.json();

            if (result.status === "success") {

                const FORMATTED_ORDER = {
                    ListID: listID ?? "",
                    CustomerID: order.CustomerID ?? "",
                    OrderID: order.OrderID ?? "",

                    Remarks: "",
                    CustomerName: order.CustomerName ?? "",
                    ItemName: order.ItemName ?? "",
                    ItemCategory: order.ItemCategory ?? "",
                    ItemQty: order.ItemQty ?? "",
                    Price: order.Price ?? "",
                    SFee: order.SFee ?? "",
                    Cargo: order.Cargo ?? "",
                    DateOrdered: order.DateOrdered ?? "",
                    PaidAmount: order.PaidAmount || 0,

                    OrderStat: result.orderStatus ?? "",
                    PayStatus: order.PayStatus ?? ""
                };

                onUpdate(FORMATTED_ORDER);

                await Swal.fire({
                    title: "Added to List",
                    text: `${order.OrderID} has been added successfully.`,
                    icon: "success",
                    timer: 1200,
                    showConfirmButton: false
                });

                setOpen(false);

            } else {

                Swal.fire({
                    title: "Unable to Add",
                    text: result.message || "Failed to add order to list.",
                    icon: "error",
                });

                setOpen(false);
            }

        } catch (error) {

            console.error(error);

            Swal.fire({
                title: "Server Error!",
                text: error.message || "Something went wrong.",
                icon: "error"
            });

            setOpen(false);

        } finally {
            setLoading(false);
        }
    };


    useBarcodeScanner(async (brcode) => {

        /*
        |--------------------------------------------------------------------------
        | Prevent another scan while processing
        |--------------------------------------------------------------------------
        */
        if (loading) {
            return;
        }

        try {

            setLoading(true);
            setOpen(true);

            const response = await fetch(
                `${apiUrl}manage_orders/get_order.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        orderID: brcode
                    })
                }
            );

            const result = await response.json();


            /*
            |--------------------------------------------------------------------------
            | Order found
            |--------------------------------------------------------------------------
            */
            if (result.status === "success") {

                const scannedOrder = result.data?.[0];

                if (!scannedOrder) {

                    Swal.fire({
                        text: "Order not found.",
                        icon: "info"
                    });

                    setOpen(false);
                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Check if already arrived / already assigned
                |--------------------------------------------------------------------------
                */
                if (scannedOrder.OrderStat === "Arrived") {

                    Swal.fire({
                        title: "Order Already Added",
                        text: scannedOrder.ListName
                            ? `This order is already in "${scannedOrder.ListName}".`
                            : "This order has already been added to a list.",
                        icon: "info"
                    });

                    setOpen(false);
                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | 🔥 DIRECTLY ADD TO LIST
                |--------------------------------------------------------------------------
                */
                await handleAddToList(scannedOrder);

            } else {

                Swal.fire({
                    text: result.message || "Failed to fetch order.",
                    icon: "info"
                });

                setOpen(false);
            }

        } catch (error) {

            console.error(error);

            Swal.fire({
                title: "Server Error!",
                text: error.message || "Something went wrong.",
                icon: "error"
            });

            setOpen(false);

        } finally {

            setLoading(false);

        }

    }, open);

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
        >

            <Paper
                elevation={6}
                sx={{
                    p: 3,
                    minWidth: 300,
                    textAlign: "center",
                    borderRadius: 3
                }}
            >

                <Stack
                    direction="column"
                    spacing={2}
                    alignItems="center"
                >

                    <CircularProgress
                        size={35}
                        color="inherit"
                    />

                    <Typography
                        variant="h6"
                        fontWeight={600}
                    >
                        Processing Order
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            opacity: 0.7
                        }}
                    >
                        Adding scanned order to the list...
                    </Typography>

                </Stack>

            </Paper>

        </Backdrop>
    );
}